import React, { FC } from 'react'
import styles from '../../styles'
import { Grid } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import ContactsTable from './components/ContactsTable'
import HeaderRechercheContact from './components/HeaderRechercheContact'

const RechercheContact: FC = () => {
	const { classes, cx } = useStyles()

	const titleStyle = cx(
		classes.title2,
		classes.titleContainer
	)

	return (
		<Grid container item className={classes.rechercheContactContainer}>
			<Grid container item spacing="10px">
				<Grid container item>
					<span className={titleStyle}>
						<FormattedMessage
							id="rechercheContact.title"
							defaultMessage="Recherche du contact"
							description="Recherche du contact"
						/>
					</span>
				</Grid>
				<Grid container item>
					<HeaderRechercheContact />
					<ContactsTable />
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	rechercheContactContainer: {
		padding: '0px 20px'
	},
	titleContainer: {
		padding: 16
	}
}))

export default RechercheContact